import React from 'react'
import Datagrid from '../../Component/Table/index'

export default (props) => <Datagrid type="resa"/>





// WEBPACK FOOTER //
// ./app/App/Module/Fidelite/Page/Recherche/index.js